import { Participant, TestGroup } from 'types'

export const defaultPreQuoteAbTestValues = {
  growth_allow_previous_insurer_cancelled_direct: 'VARIANT',
  growth_increase_lead_times: 'CONTROL',
  growth_direct_ncd_declarations: 'CONTROL',
  growth_payment_intention_question: 'CONTROL',
} as const

export const defaultPostQuoteAbTestValues = {
  growth_plan_comparison_horizontal_swiping: 'CONTROL',
  marshmallow_go_2025_refresh: 'CONTROL',
} as const

export type PreQuoteAbTestName = keyof typeof defaultPreQuoteAbTestValues
export type PostQuoteAbTestName = keyof typeof defaultPostQuoteAbTestValues

export const preQuoteAbTestKeys = Object.keys(defaultPreQuoteAbTestValues) as PreQuoteAbTestName[]
export const postQuoteAbTestKeys = Object.keys(
  defaultPostQuoteAbTestValues,
) as PostQuoteAbTestName[]

export type PreQuoteAbTests = Record<PreQuoteAbTestName, TestGroup>
type PostQuoteAbTests = Record<PostQuoteAbTestName, TestGroup>

export type PossibleAbTests = Partial<PostQuoteAbTests & PreQuoteAbTests>

export interface AbTestContextValue {
  preQuoteAbTests: PreQuoteAbTests
  postQuoteAbTests: PostQuoteAbTests
  isPostQuoteAbTestsDefault: boolean
}

export type MapAbTestsArgs<T extends string> = {
  defaultAbTests: Record<T, TestGroup>
  abTestsData: Participant[] | undefined
  isSuccess: boolean
}
